import { hasSecondSpeaker, usesSharedSpeakerPhoto } from "./speakers";
import { SAFE_BOTTOM } from "./types";

export const TOP_BAR_H = 200;
export const BOTTOM_BAR_H = 170;

/** Single-speaker photo box, matching the historical AnimatedTDCCard layout. */
export const PHOTO_WIDTH_RATIO = 0.52;
export const PHOTO_HEIGHT_RATIO = 0.42;

export type SpeakerSlot = "primary" | "secondary";
export type SpeakerPhotoMode = "single" | "split" | "pair";

export type SpeakerPhotoLayout = {
  width: number;
  height: number;
  left: number | null;
  right: number | null;
  bottom: number;
  objectPosition: "bottom right" | "bottom center";
};

export function getSpeakerPhotoMode(opts: {
  speaker2Name?: string;
  sharedPhoto?: boolean;
}): SpeakerPhotoMode {
  if (!hasSecondSpeaker(opts)) return "single";
  return usesSharedSpeakerPhoto(opts) ? "pair" : "split";
}

export function getSpeakerPhotoLayout(opts: {
  mode: SpeakerPhotoMode;
  slot: SpeakerSlot;
  width: number;
  height: number;
  scale: number;
}): SpeakerPhotoLayout {
  const bottom = SAFE_BOTTOM + BOTTOM_BAR_H;
  const photoHeight = opts.height * PHOTO_HEIGHT_RATIO * opts.scale;

  if (opts.mode === "single") {
    return {
      width: opts.width * PHOTO_WIDTH_RATIO * opts.scale,
      height: photoHeight,
      left: null,
      right: 0,
      bottom,
      objectPosition: "bottom right",
    };
  }

  if (opts.mode === "pair") {
    const pairWidth = opts.width * opts.scale;
    return {
      width: pairWidth,
      height: photoHeight,
      left: (opts.width - pairWidth) / 2,
      right: null,
      bottom,
      objectPosition: "bottom center",
    };
  }

  return {
    width: (opts.width / 2) * opts.scale,
    height: photoHeight,
    left: opts.slot === "primary" ? 0 : null,
    right: opts.slot === "secondary" ? 0 : null,
    bottom,
    objectPosition: "bottom center",
  };
}
